export const DEFAULT_SEARCH_LIST = [];
export const DELAY_GAMES_SEARCH = 200;
